import { CalendarIcon } from 'lucide-react'
import { useState } from 'react'

import { generateMonthOptions } from 'utils/dateOptions'

import ComboboxMultiSelectFilter from '../../reusable/table/ComboboxMultiSelectFilter'
import FilterManagementDropdown from '../needs_attention/FilterManagementDropdown'
import { filterByLabelAndValueCallback } from '../needs_attention/utils'
import { type SingleSelectedValueFilter } from '../types'

const CoverageStartDateFilter = ({
  selectValue,
  selectedValue,
  rangeType,
}: SingleSelectedValueFilter & { rangeType: string }) => {
  const [query, setQuery] = useState('')
  const { futureOptions, pastOptions } = generateMonthOptions(12, 12)

  // Combine all options for the dropdown trigger display
  const allOptions = [...futureOptions, ...pastOptions]

  const handleSelect = (value: string) => {
    // For single select, if the value is already selected, deselect it
    if (selectedValue === value) {
      selectValue('')
    } else {
      selectValue(value)
    }
  }

  // Filter options based on search query
  const filteredFutureOptions = futureOptions.filter(
    filterByLabelAndValueCallback(query)
  )
  const filteredPastOptions = pastOptions.filter(
    filterByLabelAndValueCallback(query)
  )

  // Convert single value to array format for ComboboxMultiSelectFilter
  const selectedValues = selectedValue ? [selectedValue] : []

  return (
    <div>
      <ComboboxMultiSelectFilter
        selectedValues={selectedValues}
        onSelectValue={handleSelect}
        options={[
          {
            groupLabel: 'Current / Future',
            options: filteredFutureOptions,
          },
          {
            groupLabel: 'Past',
            options: filteredPastOptions,
          },
        ]}
        placeholder={`Search months for ${rangeType.toLowerCase()}...`}
        onValueChange={setQuery}
      >
        <FilterManagementDropdown
          selectedValues={selectedValues}
          options={allOptions}
          noSelectionText={`${rangeType} date`}
          pluralIdentifier='date'
        >
          <CalendarIcon size={20} />
        </FilterManagementDropdown>
      </ComboboxMultiSelectFilter>
    </div>
  )
}

export default CoverageStartDateFilter
